"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTransferMiddleware = void 0;
const react_1 = __importDefault(require("react"));
const useWorkspace_1 = require("@app/util/hooks/useWorkspace");
/**
 *
 * @throws current workspace id cannot be undefined
 */
const useTransferMiddleware = ({ initialData, existingShiftData, setToggledSections, toggledSections, }) => {
    const workspace = (0, useWorkspace_1.useWorkspace)();
    const shiftData = { ...initialData?.data, ...existingShiftData };
    const [targetWsId, setTargetWsId] = react_1.default.useState();
    let slave = null;
    const slavePartial = shiftData.transfer?.slaves?.find((slave) => Boolean(slave?.workspaceId));
    if (slavePartial?.workspaceId && slavePartial.workspaceName) {
        slave = {
            workspaceId: slavePartial.workspaceId,
            workspaceName: slavePartial.workspaceName,
            positionName: slavePartial.positionName || undefined,
        };
    }
    let master = null;
    const masterPartial = shiftData.transfer?.master;
    if (masterPartial?.workspaceId && masterPartial.workspaceName) {
        master = {
            workspaceId: masterPartial.workspaceId,
            workspaceName: masterPartial.workspaceName,
            positionName: masterPartial.positionName || undefined,
        };
    }
    const transferType = initialData?.subType === 'dsProTransfer' ? 'dsProTransfer' : 'request';
    let transferStatus = 'none';
    if (targetWsId || transferType === 'dsProTransfer') {
        transferStatus = 'create';
    }
    if (slave ||
        master ||
        (transferType === 'dsProTransfer' && initialData?.shiftId)) {
        transferStatus = 'accepted';
    }
    const transferActionId = shiftData.requestPendingAction;
    if ((slave || master) && transferActionId) {
        transferStatus = 'pending';
    }
    let transferRole = null;
    if (slave)
        transferRole = 'master';
    if (master)
        transferRole = 'slave';
    react_1.default.useEffect(() => {
        if ((slave || master || transferType === 'dsProTransfer') &&
            !toggledSections.includes('transfer')) {
            setToggledSections((current) => [...current, 'transfer']);
        }
    }, [master, toggledSections, slave, setToggledSections, transferType]);
    // make sure we are in sync, eg when template is selected
    react_1.default.useEffect(() => {
        if (targetWsId && !slave && !master && !toggledSections.includes('transfer')) {
            setTargetWsId(undefined);
        }
    }, [master, setToggledSections, slave, targetWsId, toggledSections]);
    react_1.default.useEffect(() => {
        if (transferRole === 'master') {
            setToggledSections((current) => {
                return current.filter((section) => {
                    return (section !== 'localities' &&
                        !workspace?.shiftAttributes?.some((att) => att?.id === section));
                });
            });
        }
    }, [transferRole, setToggledSections, workspace?.shiftAttributes]);
    return {
        targetWsId,
        setTargetWsId,
        transferStatus,
        transferType,
        transferRole,
        transferActionId,
        transferMaster: master,
        transferSlave: slave,
    };
};
exports.useTransferMiddleware = useTransferMiddleware;
